import React, { useState, useEffect } from "react";
import "./index.scss";
import BtnLine from "../../../components/BtnLine";

const Contact = (props) => {
  const { defaultEmail, defaultEmailClear, handlePopTip } = props;
  const [inputName, setInputName] = useState('');
  const [inputEmail, setInputEmail] = useState('');
  const [inputMessage, setInputMessage] = useState('');

  const handleSubmit = () => {
    if ([inputName, inputEmail, inputMessage].includes('')) {
      return handlePopTip({
        id: 'tip-contact-submit-failed',
        visible: true,
        result: 'failed',
        msg: '尚有欄位未填寫！'
      })
    }
    const contactForm = {
      'entry.722967256': inputName,
      'entry.1649003121': inputEmail,
      'entry.476976221': inputMessage
    }

    const url =
      'https://docs.google.com/forms/u/0/d/e/1FAIpQLScZKSDZawP7Q1jXEBPVUvVZOJlI73x2PEfRYhicQJqoR3fMtA/formResponse';
    const formBody = Object.keys(contactForm)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(contactForm[key]))
      .join('&');
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      mode: 'no-cors',
      body: formBody,
    }).then(response => {
      handlePopTip({
        id: 'tip-contact-submit-success',
        visible: true,
        result: 'success',
        msg: '傳送資料成功！'
      })
      handleReset();
    });
  }

  const handleReset = () => {
    setInputName('')
    setInputEmail('')
    setInputMessage('')
    defaultEmailClear()
  }

  useEffect(() => {
    setInputEmail(defaultEmail)
  }, [defaultEmail])

  return (
    <div className="contact" id="contact">
      <div className="line-divider" />
      {/* <div className="title">Contact Us</div> */}
      <div className="title">想了解更多嗎？</div>
      <div className="title">
        <BtnLine
          style={{
            width: 250,
            borderRadius: 10,
            fontSize: '1em',
          }}
        />
      </div>

      <div className="title" style={{ display: 'flex', alignItems: 'center', }}>
        <span>或是留下您的聯絡資料</span>
      </div>
      <div className="title">我們會線上提供更詳細的資訊</div>
      <div style={{ width: '80%', marginTop: 50 }}>
        <input
          id="input-name"
          placeholder="Name"
          value={inputName}
          onChange={e => setInputName(e.target.value)}
        />
        <input
          id="input-email"
          placeholder="Email or other contact"
          value={inputEmail}
          onChange={e => setInputEmail(e.target.value)}
        />
      </div>
      <div style={{ width: '80%' }}>
        <textarea
          id="input-message"
          placeholder="Message"
          value={inputMessage}
          onChange={e => setInputMessage(e.target.value)}
        />
      </div>
      <div>
        <button
          id="btn-reset"
          onClick={() => handleReset()}
        >
          Reset
        </button>
        <button id="btn-submit" onClick={() => handleSubmit()}>Submit</button>
      </div>
    </div>
  )
}


export default Contact;